import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import u1 from "../asset/u1.png";
import u2 from "../asset/u2.png";
import u3 from "../asset/u3.png";
import u4 from "../asset/u4.png";
import u5 from "../asset/u5.png";
import u6 from "../asset/u6.png";
import u7 from "../asset/u7.png";
import u8 from "../asset/u8.png";
import u9 from "../asset/u9.png";
import u10 from "../asset/u10.png";
import u11 from "../asset/u11.png";
import u12 from "../asset/u12.png";
import u13 from "../asset/u13.jpg";
import u14 from "../asset/u14.png";
import halfCircleBlue from "../asset/half_circle_blue.png";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100%",
      minWidth: "auto",
    },
  },
  body: {
    alignItems: "center",
    width: "100%",
    maxHeight: 1114,
    minHeight: 750,
    height: "100%",
    alignSelf: "center",
    textAlign: "center",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "auto",
      height: "100%",
      margin: "12px 20px",
      maxHeight: "none",
      borderTop: "none",
    },
  },
  topTitleCon: {
    display: "flex",
    width: 74,
    flexDirection: "column",
    position: "relative",
    right: 350,
    marginBottom: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 100,
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    color: "#204FA1",
    // marginTop: 30,
    maxWidth: 1290,
    fontSize: "18px",
  },
  univBox: {
    position: "relative",
    background: "#fdf5fd",
    width: "100%",
    height: 620,
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: "100%",
    },
  },
  univWrap: {
    position: "relative",
    display: "block",
    alignSelf: "center",
    width: 840,
    overflow: "hidden",
    background: "#fff",
    textAlign: "left",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  imgUniv: {
    width: "1076px",
    marginBottom: "44px",
    border: "1px solid #EB4FE5",
    padding: "40px 40px",
  },
  mUnivBox: {
    width: "100%",
    background: "#fdf5fd",
    display: "flex",
    justifyContent: "center",
  },
  mUniWrap: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      flexDirection: "column",
      width: 290,
      alignItems: "center",
      background: "#fff",
      margin: "25px",
    },
  },
  mUnivImage: {
    width: 200,
    margin: 20,
  },

  univImage: {
    width: 100,
    margin: "50px 55px",
  },
  halfCircleBlue: {
    position: "relative",
    width: 65,
    height: 20,
    right: 30,
    bottom: 5,
    // bottom: 25,
    // right: 45,
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
}));

export const ResultPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTitleCon}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            사업성과
          </Typography>
        </div>
        <div className={classes.univBox}>
          <div className={classes.univWrap}>
            {/* <img src={univ_group} alt="대학1" className={classes.imgUniv} /> */}
            <img src={u1} alt="강릉원주대학교" className={classes.univImage} />
            <img src={u2} alt="경동대학교" className={classes.univImage} />
            <img src={u3} alt="경인여자대학교" className={classes.univImage} />
            <img src={u4} alt="국제대학교" className={classes.univImage} />
            <img src={u5} alt="극동대학교" className={classes.univImage} />
            <img src={u6} alt="기독간호대학교" className={classes.univImage} />
            <img src={u7} alt="상지대학교" className={classes.univImage} />
            <img src={u8} alt="세명대학교" className={classes.univImage} />
            <img src={u9} alt="순천향대학교" className={classes.univImage} />
            <img src={u10} alt="우석대학교" className={classes.univImage} />
            <img src={u11} alt="청주대학교" className={classes.univImage} />
            <img src={u12} alt="한양대학교" className={classes.univImage} />
            <img src={u13} alt="경일대학교" className={classes.univImage} />
            <img src={u14} alt="위덕대학교" className={classes.univImage} />
          </div>
        </div>
        <div className={classes.mUnivBox}>
          <div className={classes.mUniWrap}>
            <img src={u1} alt="강릉원주대학교" className={classes.mUnivImage} />
            <img src={u2} alt="경동대학교" className={classes.mUnivImage} />
            <img src={u3} alt="경인여자대학교" className={classes.mUnivImage} />
            <img src={u4} alt="국제대학교" className={classes.mUnivImage} />
            <img src={u5} alt="극동대학교" className={classes.mUnivImage} />
            <img src={u6} alt="기독간호대학교" className={classes.mUnivImage} />
            <img src={u7} alt="상지대학교" className={classes.mUnivImage} />
            <img src={u8} alt="세명대학교" className={classes.mUnivImage} />
            <img src={u9} alt="순천향대학교" className={classes.mUnivImage} />
            <img src={u10} alt="우석대학교" className={classes.mUnivImage} />
            <img src={u11} alt="청주대학교" className={classes.mUnivImage} />
            <img src={u12} alt="한양대학교" className={classes.mUnivImage} />
            <img src={u13} alt="경일대학교" className={classes.mUnivImage} />
            <img src={u14} alt="위덕대학교" className={classes.mUnivImage} />
          </div>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
